import { render, staticRenderFns } from "./MasiveEmailModule.vue?vue&type=template&id=c151f70a"
import script from "./MasiveEmailModule.vue?vue&type=script&lang=js"
export * from "./MasiveEmailModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports